import {
  MorphemePanelContent,
  MorphemeInfoPanelCaligraphyTab,
} from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content";
import { useInfoGraphemeMorphemeSliceQueryOptions } from "@-/dev.improve.haniverse.lib.morpheme.read";
import { usePrefetchedSuspenseQuery } from "@-/com.npmjs.tanstack__react-query";
import { MorphemeNotFound } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.not-found";

export function GraphemeInfoCaligraphyScreenSuspense({ character }: { character: string }) {
  const infoGraphemeMorphemeSliceQueryOptions = useInfoGraphemeMorphemeSliceQueryOptions(character);
  const { data: infoBackCardSlice } = usePrefetchedSuspenseQuery(
    infoGraphemeMorphemeSliceQueryOptions,
  );

  if (infoBackCardSlice === null) {
    return <MorphemeNotFound morpheme={character} />;
  }

  return (
    <MorphemePanelContent
      infoBackCardSlice={infoBackCardSlice}
      infoBackCardSliceQueryKey={infoGraphemeMorphemeSliceQueryOptions.queryKey}
    >
      <MorphemeInfoPanelCaligraphyTab />
    </MorphemePanelContent>
  );
}
